import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 mt-4" }
const _hoisted_2 = {
  class: "block",
  href: "/Шаблон оптовое создание заказов для KCELL.xlsx",
  download: "Шаблон оптовое создание заказов для KCELL.xlsx"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "auto",
    title: "Оптовое создание заказа Excel",
    "confirm-button-text": "Создать заказ",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.createOrder
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        type: "date",
        value: _ctx.state.date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.date) = $event)),
        min: _ctx.min_date,
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_form$.date.$error,
        "validation-errors": _ctx.state_form$.date.$errors,
        placeholder: "Дата отправки",
        onChange: _ctx.onDateSelected
      }, null, 8, ["value", "min", "disabled", "is-invalid", "validation-errors", "onChange"]),
      _createVNode(_component_the_select, {
        class: "mt-4",
        disabled: !_ctx.state.date || !_ctx.state.is_period_check || _ctx.state.is_loading,
        placeholder: "Период отправки",
        value: _ctx.state.period_id,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.period_id) = $event)),
        loading: _ctx.data_state.periods.is_loading,
        failed: _ctx.data_state.periods.is_failed,
        "error-text": "При получении списка периодов произошла ошибка",
        searchable: false,
        options: _ctx.getPeriods,
        onChange: _ctx.onPeriodSelected,
        onRefresh: _ctx.loadPeriods,
        label: "title"
      }, null, 8, ["disabled", "value", "loading", "failed", "options", "onChange", "onRefresh"]),
      _createVNode(_component_checkbox, {
        class: "mt-4",
        label: "Выбрать период отправки",
        disabled: _ctx.state.is_loading,
        value: _ctx.state.is_period_check,
        "onUpdate:value": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.is_period_check) = $event)),
          _ctx.onCheckboxChange
        ]
      }, null, 8, ["disabled", "value", "onUpdate:value"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_file_reader, {
          class: "flex-1",
          value: _ctx.state.file,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.file) = $event)),
          placeholder: "Оптовое создание заказов для KCELL",
          accept: ".xlsx",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.file.$error,
          "validation-errors": _ctx.state_form$.file.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createElementVNode("a", _hoisted_2, [
          _createVNode(_component_the_button, {
            hint: "Скачать шаблон",
            class: "primary small"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}